import React, { HTMLAttributes } from 'react';

import styles from './three-dots-loader.module.css';

interface ThreeDotsLoaderProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
}

function ThreeDotsLoader({ color = 'var(--saral-purple)', ...rest }: ThreeDotsLoaderProps) {
  return (
    <div {...rest} className={styles.ellipsisLoader}>
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
    </div>
  );
}

export default ThreeDotsLoader;
